import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const ButtonContainer = styled.div`
    margin-left: auto;

    div {
        margin-right: 8px;
    }
`;

ButtonContainer.displayName = "ButtonContainer";

export const ItemContainer = styled(FlexRow)`
    box-sizing: border-box;
    align-items: center;
    gap: 16px;
    border: 1px solid ${carbon[50]};
    border-radius: 3px;

    padding: 16px;
    cursor: pointer;

    &:hover {
        box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
        border: 1px solid ${carbon[100]};
    }
`;

ItemContainer.displayName = "ItemContainer";
